import get from 'lodash/get';

export default {
    methods: {
        getNestedValue(cell) {
            return get(this.appResource, cell);
        },

        countResources(cell) {
            if(Array.isArray(cell)) {
                let result = 0;
                cell.forEach((cellField) => {
                    result += this.countResources(cellField);
                });
                return result;
            }

            const value = this.getNestedValue(cell);

            return value !== undefined ? value.length : 0;
        },

        getNestedValueFor(appResource, cell) {
            return get(appResource, cell);
        },
    },
};
